/* Store locator (sections/locator-map): load Stockist's widget script once the map frame is near the viewport, so it
   never competes with the hero. Stockist finds <stockist-store-locator> and renders the map into it. */
(() => {
  const SRC = 'https://stockist.co/embed/v1/widget.min.js';
  const frame = document.querySelector('[data-kx-stockist]');
  if (!frame) return;
  let loaded = false;
  const load = () => {
    if (loaded || document.querySelector(`script[src="${SRC}"]`)) return;
    loaded = true;
    const s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    document.head.appendChild(s);
  };
  if (!('IntersectionObserver' in window)) return load();
  const io = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) { io.disconnect(); load(); }
  }, { rootMargin: '600px 0px' });
  io.observe(frame);
})();
